
URL = globalThis.URL
import __vite__wasmUrl from "/app/packages/sim-wasm/pkg/aod_sim_wasm_bg.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"
import * as __vite__wasmImport_0 from "./aod_sim_wasm_bg.js";
const __vite__wasmModule = await __vite__initWasm({ "./aod_sim_wasm_bg.js": { "__wbg_length_b03a0fabb109b1e9": __vite__wasmImport_0["__wbg_length_b03a0fabb109b1e9"],
"__wbg_get_unchecked_e6325ad374eff861": __vite__wasmImport_0["__wbg_get_unchecked_e6325ad374eff861"],
"__wbg_next_af5ac6a08bb0a717": __vite__wasmImport_0["__wbg_next_af5ac6a08bb0a717"],
"__wbg_done_57e08d0be6e30c02": __vite__wasmImport_0["__wbg_done_57e08d0be6e30c02"],
"__wbg_value_e0f328965e184931": __vite__wasmImport_0["__wbg_value_e0f328965e184931"],
"__wbg_set_d2d33b52458e984a": __vite__wasmImport_0["__wbg_set_d2d33b52458e984a"],
"__wbg_set_8282f7e0d2d01336": __vite__wasmImport_0["__wbg_set_8282f7e0d2d01336"],
"__wbg_now_accf71f8a5673962": __vite__wasmImport_0["__wbg_now_accf71f8a5673962"],
"__wbg_now_03a99c089e92328a": __vite__wasmImport_0["__wbg_now_03a99c089e92328a"],
"__wbg_instanceof_Map_0b4fc8b62e73f163": __vite__wasmImport_0["__wbg_instanceof_Map_0b4fc8b62e73f163"],
"__wbg_get_d7176cfb76d71114": __vite__wasmImport_0["__wbg_get_d7176cfb76d71114"],
"__wbg_get_with_ref_key_fc601247060b7204": __vite__wasmImport_0["__wbg_get_with_ref_key_fc601247060b7204"],
"__wbg_set_e4b9a833d288759a": __vite__wasmImport_0["__wbg_set_e4b9a833d288759a"],
"__wbg_String_8564e559799eccda": __vite__wasmImport_0["__wbg_String_8564e559799eccda"],
"__wbg_new_bb74001155cb8ca8": __vite__wasmImport_0["__wbg_new_bb74001155cb8ca8"],
"__wbg_stack_575c4e0918581b9c": __vite__wasmImport_0["__wbg_stack_575c4e0918581b9c"],
"__wbg_error_757e9472f8410341": __vite__wasmImport_0["__wbg_error_757e9472f8410341"],
"__wbg_new_7075786089b89c5e": __vite__wasmImport_0["__wbg_new_7075786089b89c5e"],
"__wbg_new_37eb45aaf5eeb820": __vite__wasmImport_0["__wbg_new_37eb45aaf5eeb820"],
"__wbg_new_cd4348290afae586": __vite__wasmImport_0["__wbg_new_cd4348290afae586"],
"__wbg_new_13de428334042d26": __vite__wasmImport_0["__wbg_new_13de428334042d26"],
"__wbg_length_186163212ffe79c3": __vite__wasmImport_0["__wbg_length_186163212ffe79c3"],
"__wbg_prototypesetcall_13162965d1fe7aa3": __vite__wasmImport_0["__wbg_prototypesetcall_13162965d1fe7aa3"],
"__wbg_instanceof_Uint8Array_d7aeb0dcb3108fea": __vite__wasmImport_0["__wbg_instanceof_Uint8Array_d7aeb0dcb3108fea"],
"__wbg_instanceof_ArrayBuffer_12cdaa4161423e6b": __vite__wasmImport_0["__wbg_instanceof_ArrayBuffer_12cdaa4161423e6b"],
"__wbg_now_463ac581d2fc7ea3": __vite__wasmImport_0["__wbg_now_463ac581d2fc7ea3"],
"__wbg_isArray_bcf1376d0d732d08": __vite__wasmImport_0["__wbg_isArray_bcf1376d0d732d08"],
"__wbg_new_787b9fb330d55d78": __vite__wasmImport_0["__wbg_new_787b9fb330d55d78"],
"__wbg_isSafeInteger_1a35ba4d31e71d38": __vite__wasmImport_0["__wbg_isSafeInteger_1a35ba4d31e71d38"],
"__wbg_entries_7bb1459bd9b5c2b9": __vite__wasmImport_0["__wbg_entries_7bb1459bd9b5c2b9"],
"__wbg_iterator_e4c5e8f68ada7b58": __vite__wasmImport_0["__wbg_iterator_e4c5e8f68ada7b58"],
"__wbg_next_178c1651c11432b3": __vite__wasmImport_0["__wbg_next_178c1651c11432b3"],
"__wbg_get_635eea311fa1a291": __vite__wasmImport_0["__wbg_get_635eea311fa1a291"],
"__wbg_call_40b008ba32f73991": __vite__wasmImport_0["__wbg_call_40b008ba32f73991"],
"__wbg___wbindgen_string_get_7ce8eee7fd327545": __vite__wasmImport_0["__wbg___wbindgen_string_get_7ce8eee7fd327545"],
"__wbg___wbindgen_number_get_934b640d0889af78": __vite__wasmImport_0["__wbg___wbindgen_number_get_934b640d0889af78"],
"__wbg___wbindgen_in_3f58a9d3b3a7eed2": __vite__wasmImport_0["__wbg___wbindgen_in_3f58a9d3b3a7eed2"],
"__wbg___wbindgen_throw_4c88d8bf264fd984": __vite__wasmImport_0["__wbg___wbindgen_throw_4c88d8bf264fd984"],
"__wbg___wbindgen_is_null_c22311b1cc228e3a": __vite__wasmImport_0["__wbg___wbindgen_is_null_c22311b1cc228e3a"],
"__wbg___wbindgen_jsval_eq_38d7bfbe4cc84039": __vite__wasmImport_0["__wbg___wbindgen_jsval_eq_38d7bfbe4cc84039"],
"__wbg_Number_ff192a72a0dcdf6d": __vite__wasmImport_0["__wbg_Number_ff192a72a0dcdf6d"],
"__wbg_Error_208446807d0d1e30": __vite__wasmImport_0["__wbg_Error_208446807d0d1e30"],
"__wbg___wbindgen_is_bigint_5fa10641e039d3ef": __vite__wasmImport_0["__wbg___wbindgen_is_bigint_5fa10641e039d3ef"],
"__wbg___wbindgen_is_object_8b968c3ab8e96595": __vite__wasmImport_0["__wbg___wbindgen_is_object_8b968c3ab8e96595"],
"__wbg___wbindgen_is_string_fc456fee5d3317de": __vite__wasmImport_0["__wbg___wbindgen_is_string_fc456fee5d3317de"],
"__wbg___wbindgen_boolean_get_4f1baf9a00be3c74": __vite__wasmImport_0["__wbg___wbindgen_boolean_get_4f1baf9a00be3c74"],
"__wbg___wbindgen_is_function_741ff2bb612836f5": __vite__wasmImport_0["__wbg___wbindgen_is_function_741ff2bb612836f5"],
"__wbg___wbindgen_is_undefined_be5b34249ff1fc15": __vite__wasmImport_0["__wbg___wbindgen_is_undefined_be5b34249ff1fc15"],
"__wbg___wbindgen_jsval_loose_eq_b2f214e2e4b30e36": __vite__wasmImport_0["__wbg___wbindgen_jsval_loose_eq_b2f214e2e4b30e36"],
"__wbg___wbindgen_bigint_get_as_i64_11da4b52cd0aedef": __vite__wasmImport_0["__wbg___wbindgen_bigint_get_as_i64_11da4b52cd0aedef"],
"__wbg___wbindgen_debug_string_f249a2a76caa9a55": __vite__wasmImport_0["__wbg___wbindgen_debug_string_f249a2a76caa9a55"],
"__wbindgen_init_externref_table": __vite__wasmImport_0["__wbindgen_init_externref_table"],
"__wbindgen_generic_0000000000000001": __vite__wasmImport_0["__wbindgen_generic_0000000000000001"],
"__wbindgen_generic_0000000000000002": __vite__wasmImport_0["__wbindgen_generic_0000000000000002"],
"__wbindgen_generic_0000000000000003": __vite__wasmImport_0["__wbindgen_generic_0000000000000003"],
"__wbindgen_generic_0000000000000004": __vite__wasmImport_0["__wbindgen_generic_0000000000000004"] } }, __vite__wasmUrl);
export const {
  memory,
  __wbg_rustsimadapter_free,
  init,
  rustsimadapter_aiSnapshot,
  rustsimadapter_callFunction,
  rustsimadapter_can_advance,
  rustsimadapter_destroy,
  rustsimadapter_determinismHash,
  rustsimadapter_drainEvents,
  rustsimadapter_intent,
  rustsimadapter_isLockstep,
  rustsimadapter_listFunctions,
  rustsimadapter_load_game,
  rustsimadapter_matchSeed,
  rustsimadapter_minimapSnapshot,
  rustsimadapter_new,
  rustsimadapter_playerHud,
  rustsimadapter_player_ready,
  rustsimadapter_query,
  rustsimadapter_reset,
  rustsimadapter_save_game,
  rustsimadapter_set_expected_players,
  rustsimadapter_set_lockstep,
  rustsimadapter_snapshot,
  rustsimadapter_step,
  rustsimadapter_submitExternalIntents,
  rustsimadapter_suggestIntents,
  rustsimadapter_tick,
  __abort_handler,
  __instance_terminated,
  __wbindgen_malloc,
  __wbindgen_realloc,
  __wbindgen_free,
  __wbindgen_exn_store,
  __externref_table_alloc,
  __wbindgen_externrefs,
  __externref_table_dealloc,
  __wbindgen_start,
} = __vite__wasmModule;
